export default "__VITE_ASSET__lHr_S18y__"